import React from "react";
import { WhatsAppIcon } from "./icons/WhatsAppIcon";

const WHATSAPP_NUMBER = "56942964199";
const WHATSAPP_MSG = encodeURIComponent(
  "Hola, quiero cotizar seguro para mi comunidad."
);

/**
 * Floating WhatsApp button — visible on all public pages, bottom-right corner.
 * Includes a subtle pulse animation to attract attention.
 */
export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contáctanos por WhatsApp"
      className="fixed z-40 group"
      style={{ bottom: "24px", right: "24px" }}
      data-testid="whatsapp-float"
    >
      {/* Pulse rings */}
      <span
        className="absolute inset-0 rounded-full animate-ping opacity-40"
        style={{ background: "#25D366", animationDuration: "2.5s" }}
        aria-hidden
      />
      <span
        className="relative flex items-center gap-2.5 pl-4 pr-5 py-3.5 rounded-full shadow-2xl transition-transform group-hover:scale-105"
        style={{
          background: "#25D366",
          boxShadow: "0 8px 24px rgba(37,211,102,0.4)",
        }}
      >
        <WhatsAppIcon size={26} color="white" />
        <span className="hidden sm:inline text-[13.5px] font-bold text-white" style={{ fontFamily: "Manrope" }}>
          Contáctanos
        </span>
      </span>
    </a>
  );
}
